module.exports = __webpack_public_path__ + "img/8_26@3x.369e1741.png";